import { AnswerType } from "@/entities/questionaire/answers/AnswerType";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { AnswerVariant } from "@/entities/questionaire/answers/AnswerVariant";
import constants from "@/entities/constants";
import { expectedAnswerType } from "@/entities/questionaire/answers/ExpectedAnswerType";

export class MultipleItemsAnswer extends Answer {
  variants: AnswerVariant[];
  answers: number[] | null = null;
  texts: string[] = [];

  constructor(
    PropertyId: number,
    variants: AnswerVariant[],
    answers: number[] | null = null,
    texts: string[] = []
  ) {
    super(PropertyId);

    this.variants = variants;
    this.answers = answers;
    this.texts = texts;
  }

  static createAnswer(obj: any): MultipleItemsAnswer {
    let variants: AnswerVariant[] = [];
    if (obj.answerVariants) {
      variants = obj.answerVariants.map(
        (x: {
          id: number;
          text: string;
          expected: boolean | null;
          expectedAnswer: expectedAnswerType | expectedAnswerType.none;
        }) => {
          return new AnswerVariant(x.id, x.text, x.expectedAnswer);
        }
      );
    }

    return new MultipleItemsAnswer(obj.id, variants, [], obj.texts);
  }

  getType(): AnswerType {
    return AnswerType.MultipleItems;
  }

  isEmpty(): boolean {
    return this.answers === null;
  }

  getComponentName(): string {
    return constants.answerTypes.MultipleItemsAnswer.componentName;
  }

  getQuizResultObject(): any {
    return {
      propertyId: this.PropertyId,
      answerType: this.getType(),
      multipleItems: this.answers ?? []
    };
  }
}
